<script>
  import Google from '~icons/mdi/google';
  import Facebook from '~icons/mdi/facebook';

  import ActionButton from '~/components/ActionButton.svelte';
  import { dev } from '$app/env';
</script>

<div class="oauth">
  <ActionButton
    href="/auth/oauth?provider=google"
    outlink={false}
    class="google"
  >
    <Google />Sign in with Google
  </ActionButton>
  {#if dev}
    <ActionButton
      href="/auth/oauth?provider=facebook"
      outlink={false}
      class="facebook"
    >
      <Facebook />Sign in with Facebook
    </ActionButton>
  {/if}
</div>
<div class="separator">or</div>

<style lang="scss">
  @use 'sass:color';
  @use '~/theme/theme';
  @use '~/theme/themify' as *;

  .oauth {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5em;
    :global(.action) {
      display: flex;
      flex-direction: row;
      justify-content: center;
      gap: 0.5em;
      align-items: center;
      width: 100%;
      max-width: 24em;
    }
    :global(.action.google) {
      $google-color: #de5246;
      border-color: $google-color;
      background-color: $google-color;
      color: white;

      &:hover {
        background-color: color.adjust($google-color, $lightness: -10%);
        border-color: color.adjust($google-color, $lightness: -20%);
      }
      &:active {
        background-color: color.adjust($google-color, $lightness: 5%);
        border-color: color.adjust($google-color, $lightness: 10%);
      }
    }
    :global(.action.facebook) {
      $fb-color: #165db6;
      border-color: $fb-color;
      background-color: $fb-color;
      color: white;

      &:hover {
        background-color: color.adjust($fb-color, $lightness: -10%);
        border-color: color.adjust($fb-color, $lightness: -20%);
      }
      &:active {
        background-color: color.adjust($fb-color, $lightness: 5%);
        border-color: color.adjust($fb-color, $lightness: 10%);
      }
    }
  }
  .separator {
    width: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    font-size: 0.75em;
  }

  .separator::before,
  .separator::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid currentColor;
  }

  .separator:not(:empty)::before {
    margin-right: 1em;
  }

  .separator:not(:empty)::after {
    margin-left: 1em;
  }
</style>
